// Mirrors Dtos/SystemStatus/ServiceState.cs — serialized as an integer.
const SERVICE_STATE = Object.freeze({
    OPERATIONAL: 0,
    DEGRADED: 1,
    DOWN: 2
});

const SERVICE_STATE_LABELS = Object.freeze({
    [SERVICE_STATE.OPERATIONAL]: 'Operational',
    [SERVICE_STATE.DEGRADED]: 'Degraded',
    [SERVICE_STATE.DOWN]: 'Major Outage'
});

export { SERVICE_STATE, SERVICE_STATE_LABELS };
